export const siteConfig = {
  name: import.meta.env.VITE_APP_NAME || 'Anh trai say hi',
  description: 'Anh trai say hi management interface',
  apiUrl: import.meta.env.VITE_API_URL || '',
} as const;
